import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from "react-helmet-async";
import App from './App'
import './styles/globals.css'
import setupLocatorUI from '@locator/runtime'
import { cleanupDevServiceWorker, registerChunkErrorReload } from './lib/chunkReload'
import { registerReconnectSync } from './offline/useOffline'
import { syncNow } from './offline/sync'
import { flushFireQueue } from './offline/useReminders'

async function bootstrap() {
  // Clean stale local dev modules before rendering any route. This is a
  // one-time migration for browsers that already registered the old worker.
  if (await cleanupDevServiceWorker()) {
    window.location.reload()
    return
  }

  if (import.meta.env.DEV) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setupLocatorUI({ adapter: 'react', editor: 'cursor' } as any)
  }

  // Recover from stale lazy chunks after a deploy — must be first, before any
  // route can attempt a dynamic import.
  registerChunkErrorReload()

  // Register reconnect handler + warm the local cache on boot (field path)
  registerReconnectSync()
  if (navigator.onLine) {
    syncNow().catch(() => {})
    flushFireQueue().catch(() => {})
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>,
  )
}

void bootstrap()
